<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel-left">
                        <h2>Enviar Notificação de Cancelamento</h2>
                    </div>
                </div>
            </div>

            <div>
                <form [formGroup]="formularioInserirNotificacao" (ngSubmit)="onSubmitNovaNotificacao()"
                    (keydown.enter)="$event.preventDefault()">
                    <div class="form-group">
                        <mat-divider fxFlex="1 0"></mat-divider>
                    </div>
                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-6 col-md-6 col-sm-6 col-12">
                            <mat-label>Paciente</mat-label>
                            <input matInput value="Paciente" class="form-control" id="nomePessoaNotificacao" required
                                trim="blur" name="nomePessoaNotificacao" formControlName="nomePessoaNotificacao"
                                maxlength="60" upperCase>
                            <mat-error
                                *ngIf="formularioInserirNotificacao.controls.nomePessoaNotificacao.hasError('required')">
                                O campo Paciente é obrigatório.
                            </mat-error>
                            <mat-error
                                *ngIf="formularioInserirNotificacao.controls.nomePessoaNotificacao.hasError('minlength')">
                                O campo Paciente precisa conter mais do que 5 caracteres.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-4 col-md-4 col-sm-4 col-12">
                            <mat-label>Núm. Celular</mat-label>
                            <input matInput value="Núm. Celular" class="form-control" id="foneCelular"
                                name="foneCelular" phoneMask [maskInputId]="'foneCelular'"
                                [preValue]="formularioInserirNotificacao.value.foneCelular"
                                [phoneControl]="formularioInserirNotificacao.controls['foneCelular']"
                                formControlName="foneCelular" minlength="14" maxlength="16">
                            <mat-error *ngIf="formularioInserirNotificacao.controls.foneCelular.errors">
                                O campo Núm. Celular está inválido.
                            </mat-error>
                        </mat-form-field>

                        <div class="form-group col-lg-2 col-md-2 col-sm-2 col-12" style="align-self: center;">
                            <button mat-raised-button color="success" type="submit" matTooltip="Inserir"
                                [disabled]="!formularioInserirNotificacao.valid" style="width: 100%;">
                                Inserir
                            </button>
                        </div>
                    </div>
                </form>

                <form [formGroup]="formularioNotificacaoCanelamento" (ngSubmit)="onSubmit()"
                    (keydown.enter)="$event.preventDefault()">
                    <div class="form-group">
                        <mat-divider fxFlex="1 0"></mat-divider>
                    </div>

                    <div class="form-row">
                        <mat-form-field style="margin-top: 6.5px;"
                            class="form-group col-lg-6 col-md-6 col-sm-12 col-12">
                            <mat-label>Msg. para o Paciente</mat-label>
                            <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                cdkAutosizeMinRows="2" cdkAutosizeMaxRows="6" formControlName="dscMensagemNotificacao"
                                name="dscMensagemNotificacao" id="dscMensagemNotificacao"
                                maxlength="{{maxlengthMsgPaciente}}" upperCase required></textarea>
                        </mat-form-field>

                        <mat-form-field style="margin-top: 6.5px;"
                            class="form-group col-lg-6 col-md-6 col-sm-12 col-12">
                            <mat-label>Motivo do Cancelamento</mat-label>
                            <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                cdkAutosizeMinRows="2" cdkAutosizeMaxRows="6" formControlName="dscMotivoNotificacao"
                                name="dscMotivoNotificacao" id="dscMotivoNotificacao" maxlength="255" upperCase
                                required></textarea>
                        </mat-form-field>
                    </div>

                    <table mat-table [dataSource]="dataSource" matSort class="table table-striped">
                        <ng-container matColumnDef="nomePessoaNotificacao">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Paciente </th>
                            <td mat-cell *matCellDef="let notificacaoSms"> {{notificacaoSms.nomePessoaNotificacao}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="numTelefone">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Telefone </th>
                            <td mat-cell *matCellDef="let notificacaoSms"> {{notificacaoSms.pk.numTelefone | mask:
                                mascaraFoneCustom(notificacaoSms.pk.numTelefone)}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef class="table-column-center"> Status </th>
                            <td mat-cell *matCellDef="let notificacaoSms" class="table-column-center">
                                <mat-icon class="mat-18" color="{{notificacaoSms.getCorTipoStatusNotificacao()}}"
                                    style="vertical-align: middle;"
                                    matTooltip="{{notificacaoSms.getTooltipTipoStatusNotificacao()}}">
                                    {{notificacaoSms.getIconeTipoStatusNotificacao()}}
                                </mat-icon>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>

                    <div class="menu-formulario">
                        <div class="menu-formulario-botoes margin-right-10">
                            <button mat-mini-fab color="success" type="submit" matTooltip="Enviar"
                                [disabled]="!formularioNotificacaoCanelamento.valid">
                                <mat-icon>save</mat-icon>
                            </button>
                        </div>
                        <div class="menu-formulario-botoes">
                            <button type="button" mat-mini-fab color="primary" (click)="gotoList()" matTooltip="Voltar">
                                <mat-icon>west</mat-icon>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>